import {  Form, Input,Divider } from 'antd';
const { TextArea } = Input;

import './index.scss'
import {useEffect, useState} from "react";
import { removeEmojiCodes } from '../../services/helper';
import { useTranslation } from 'react-i18next';

const TextAreaField = (props: any) => {
  const {t} = useTranslation()
  const [value, setValue] = useState(props.value || '');
  const [maxLength, setMaxLength] = useState<number>(props.maxLength || 140);
  const [symbolCount, setSymbolCount] = useState<number>(maxLength);
  const [maxRows, setMaxRows] = useState<any>(5);
  const input_name=props.name || '';
  const [disabled, setDisabled] = useState<boolean>(props.disabled || false)
  const [readOnly, setReadOnly] = useState<boolean>(props.readOnly || false)
  const watchedValue = Form.useWatch(input_name, props.form);

  const updateValue = (get_value : string) => {
      let value_1 = props.exchangeNote ? get_value?.replaceAll(/[`~!@«»№#&;$%^*=\{\}\[\]<>_|?“”""\\\/]/gi, '') :
          (props.allowLatin ?
              get_value?.replaceAll(/[а-яА-ЯЁё]+/g, '')?.replaceAll(/[`~!@«»№#&;$%^*=\{\}\[\]<>_|?“”""\\\/]/gi, '')
              : (props.allowRus ?
                  get_value?.replaceAll(/[a-zA-ZÜüÖöĞğƏəİIıŞşÇç]+/g, '')?.replaceAll(/[`~!@«»№#&;$%^*=\{\}\[\]<>_|?“”""\\\/]/gi, '')
                  : (
                      props.allowDestination ? get_value?.replaceAll(/[а-яА-ЯЁёÜüÖöĞğƏəİıŞşÇç]+/g, '')?.replace(/[`~!@«»№#&;$%^*=\{\}\[\]<>_|?“”""\\\/]/gi, '') :
                          props.bansimvol ? get_value?.replaceAll(/[`~!@«»№#&;$%^*=\{\}\[\]<>_|?“”""\\\/]/gi, '') : get_value?.replaceAll(/[^a-zA-Z0-9 ]+/g, '')?.replaceAll(/[а-яА-ЯЁё]+/g, '')?.replaceAll(/[`~!@«»№#&;$%^*=\{\}\[\]<>_|?“”""\\\/]/gi, '')
                  )));

      let value_ = props.allowAllSymboll ? get_value : (props.exchange ? get_value?.replaceAll(/[а-яА-ЯЁё]+/g, '')?.replaceAll(/[~!@«»№#&;$%""/^*=\{\}\[\]_<>«»“”\\|?]/gi, '') : value_1);
      //value_= props.exchange ? get_value?.replace(/[`~!@«»№#&;$%^*=\{\}\[\]<>_|?“”\\\/]/gi, '') :value_1;

      if (props.allowCyrillic) {
        value_ = get_value;
      }

      if (value_?.replace(/\s/g, '').length === 0) {
        value_ = "";
      }

      if(props.upper && value_ !== undefined && value_ !== null) {
        value_ = value_?.toString().toUpperCase()
      }

      if (!props.staticValue) {
        if (props.form) {
          props.form.setFieldsValue(
              {
                [input_name]: removeEmojiCodes(value_)
              }
          );
        }
      }

      updateCounter(value_);
  }

  useEffect(() => {
    console.log(props.value)
    setSymbolCount(old_count => props.maxLength)

    updateValue(props.value);

    setDisabled(old_data => props.disabled)
    setReadOnly(old_data => props.readOnly)

  }, [props.value, props.maxLength, props.readOnly, props.disabled, props.readOnly]);
  useEffect(()=>{
    updateValue(props.value);
  console.log(props.value)
  updateCounter(props.value)
  },[props.value])
  useEffect(() => {
    if (props.showCount) {
      if(symbolCount === maxLength) {
        let value_length = props.form.getFieldValue(props.name)?.length,
            calc_row = value_length >= 210 ? 100 : 5,
            symbol_count = maxLength - value_length;
            console.log(symbolCount)
        setSymbolCount(old_value => !isNaN(symbol_count) ? symbol_count : maxLength);
        setMaxRows(old_value => calc_row);
      }
    }
  }, [props.form.getFieldValue(props.name)]);

  useEffect(() => {
    if (watchedValue !== undefined) {
      updateCounter(watchedValue);
    }
  }, [watchedValue]);

  let validate_message=props.message || '';

  if (props.required && !props.message){
    validate_message=t("newTransfer.requiredField");
  }

  const handleInputChange = (e) => {
    if (props.onChange) {
      props.onChange(e);
    }
    updateValue(e.target.value);
  }

  const onKeyPress = (e) => {
    const regex = new RegExp(/^[^!-\\/:-@\\[-`{-~]+$/);
    const regex2 = /[0123456789]|[,.]/;
    const cyrillicPattern = /[а-яА-ЯЁё]/;
    const key_code=e.which || e.keyCode;
    const value=e.target.value;
    const key = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    /*console.log(value, cyrillicPattern.test(value))

    if (props.allowCyrillic && cyrillicPattern.test(value)){
      e.preventDefault();
      return false;
    }*/
    if(props.prefix !== undefined && !value.startsWith(props.prefix)) {
      if(props.form){
        props.form.setFieldsValue(
            {
              [input_name]: props.prefix
            }
        );
      }
    }
  // || !value.startsWith(props.prefix)
        if (!props.allowAllSymboll && !props.allowRus && !props.exchangeNote && cyrillicPattern.test(value) && !regex2.test(key)) {
          e.preventDefault();
          return false;
        } else {
          updateCounter();
        }

  }

  const onPaste = (e:any) => {
  
    updateCounter();
  }

  const updateCounter = (get_val : any = false) => {
    if (props.showCount){
      let value_length=get_val ? get_val.length : props.form.getFieldValue(props.name)?.length,
          calc_row=value_length >= 210 ? 100 : 5,
          symbol_count=maxLength - value_length;
      setSymbolCount(() => !isNaN(symbol_count) ? symbol_count : maxLength);
      setMaxRows(() => calc_row);
    }
  }

  const onReset = () => {

    if (props.staticValue){
      updateValue(props.value);
    }


    updateCounter();

    let current_input=document.querySelector(`#${input_name}`);

    if (current_input?.classList.contains('isReadOnly')){
      setReadOnly(old_data => true)
    }

    if (current_input?.classList.contains('isDisabled')){
      setDisabled(old_data => true)
    }

  }

  let divClass='custom_input_component custom_textarea_component';

  if (props.readOnly){
    divClass+=' input_readonly  '
  }

  if (disabled){
    divClass+=' input_disabled  '
  }

  divClass+=(props.visible) ? ' show_text_area  ' : ' hide_text_area  '

  return (
    <div className={divClass} key={props.name} >
      <Form.Item
        name={input_name}
        label={props.labelItem}
        labelCol={props.labelCol}
        wrapperCol={props.wrapperCol}
        className={`${props?.className} input-field text_area`}
        rules={[{ required: props.required || false, message : validate_message }]}
        style={{/*display : props.visible ? 'flex' : 'none',*/ alignItems: !props.visible ? 'center' : 'flex-start' }}
        onReset={onReset}
        shouldUpdate={(prevValues, curValues) => {
          if (prevValues[input_name]!==curValues[input_name]){
            setDisabled(old_value => false)
          }

          return true;
        }}
      >


        <TextArea
            maxLength={maxLength}
            placeholder={props.placeholder}
            autoSize={{ minRows: props.minRows ||  2, maxRows: maxRows }}
            className = {props.className || ''}
            readOnly={readOnly}
            disabled={disabled}
            onChange={handleInputChange}
            style={props.style}
            size={props.size}
            onKeyUp={onKeyPress}
            onKeyPress={onKeyPress}
            onPaste={onPaste}
            name={input_name}
            

        />

      </Form.Item>

      {
          props.showCount && <div  style={{display : props.visible ? 'flex' : 'none'}} className={'show_input_counter'}><span className={'show_symbol_count'} >{symbolCount < 0 ? 0 : symbolCount}</span>/{maxLength}</div>
      }

      {
          !props.visible && <Divider/>
      }
    </div>
  )
}

export default TextAreaField
